import { actionTypes, mutationTypes, getterTypes } from './specification.moduletypes';

const actions = {
  [actionTypes.getAllUnitsWithSpecification]({ getters, commit }) {
    return new Promise(resolve => {
      getters[getterTypes.SpecificationApi].getUnitsWithSpecifications().then(result => {
        let { data } = result;
        commit(mutationTypes.setAllUnitsWithSpecifications, data);
        resolve(result);
      });
    });
  },

  [actionTypes.getAllSpecificationSelections]({ getters, commit }) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.SpecificationApi]
        .getAllSpecificationSelections()
        .then(result => {
          let { data } = result;
          commit(mutationTypes.addSpecificationSelections, data);
          resolve(data);
        })
        .catch(error => {
          console.error('Error occured get all specification: ' + error);
          reject(error);
        });
    });
  },

  [actionTypes.saveSpecification]({ getters }, { data }) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.SpecificationApi]
        .saveSpecification(data)
        .then(result => {
          let { data } = result;
          resolve(data);
        })
        .catch(error => {
          console.error('Error occured get save specification: ' + error);
          reject(error);
        });
    });
  },

  [actionTypes.assignSpecification]({ getters, commit }, { data }) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.SpecificationApi]
        .assignSpecification(data)
        .then(result => {
          let { data } = result;
          commit(mutationTypes.setAllUnitsWithSpecifications, data);
          resolve(result);
        })
        .catch(error => {
          console.error('Error occured in assign specification: ' + error);
          reject();
        });
    });
  },
  [actionTypes.deleteSpecification]({ getters, commit }, specGuid) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.SpecificationApi]
        .deleteSpecification(specGuid)
        .then(() => {
          commit(mutationTypes.deleteSpecification, specGuid);
          resolve();
        })
        .catch(error => {
          console.error('Error occured in delete specification: ' + error);
          reject();
        });
    });
  },

  [actionTypes.getSingleSpecification]({ getters, commit }, specGuid) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.SpecificationApi]
        .getSingleSpecification(specGuid)
        .then(result => {
          let { data } = result;
          commit(mutationTypes.setSingleSpecification, data);
          resolve();
        })
        .catch(error => {
          console.error('Error occured in get single specification: ' + error);
          reject();
        });
    });
  },

  [actionTypes.updateSpecification]({ getters, commit }, data) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.SpecificationApi]
        .updateSpecification(data)
        .then(result => {
          let { data } = result;
          commit(mutationTypes.setAllUnitsWithSpecifications, data);
          resolve(result);
        })
        .catch(error => {
          console.error('Error occured in update specification: ' + error);
          reject();
        });
    });
  },

  [actionTypes.editSpecification]({ dispatch }, { updateData, assignSpecification }) {
    return new Promise(resolve => {
      let promises = [];
      // we first update information of specification and then we assign/copy
      promises.push(
        dispatch(actionTypes.updateSpecification, updateData).then(() => {
          dispatch(actionTypes.assignSpecification, {
            data: assignSpecification
          });
        })
      );

      return Promise.all(promises).then(() => {
        resolve();
      });
    });
  },

  [actionTypes.unassignSpecification]({ getters, commit }, data) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.SpecificationApi]
        .unassignSpecification(data)
        .then(() => {
          resolve();
        })
        .catch(error => {
          console.error('Error occured in unassign specification: ' + error);
          reject();
        });
    });
  }
};

export default actions;
